import React, {PureComponent} from 'react';
import { hashHistory } from "react-router";
import classnames from 'classnames';
import {FormattedMessage} from "react-intl";

class HomeButton extends PureComponent {
  render() {
    return (
      <button className={classnames({"materials-button materials-button--home": !this.props.className, [this.props.className]: this.props.className})}
              onClick={() => hashHistory.push('quote-design')}>
        <span className="materials-button__text"><FormattedMessage id="homeButton.main"/></span>
      </button>
    );
  }
}

export default HomeButton
